import { Select, MenuItem, TextField } from '@mui/material';

export function DefaultFilter({ column }) {
  const columnFilterValue = column.getFilterValue();
  return (
    <TextField
      type="text"
      size="small"
      value={columnFilterValue ?? ''}
      onChange={(e) => column.setFilterValue(e.target.value)}
      placeholder={'Search...'}
    />
  );
}

export const ApplicationStatusFilter = ({ options, column }) => {
  const columnFilterValue = column.getFilterValue();
  return (
    <Select
      size="small"
      sx={{ width: '150px' }}
      value={columnFilterValue ?? ''}
      onChange={(e) => column.setFilterValue(e.target.value)}
    >
      <MenuItem value="">None</MenuItem>
      {options?.split('\n').map((el) => (
        <MenuItem key={el} value={el}>
          {el}
        </MenuItem>
      ))}
    </Select>
  );
};

export const BooleanFilter = ({ column }) => {
  const columnFilterValue = column.getFilterValue();
  return (
    <Select
      size="small"
      sx={{ minWidth: '100px' }}
      value={columnFilterValue ?? ''}
      onChange={(e) =>
        column.setFilterValue(e.target.value ? e.target.value == 'true' : '')
      }
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="true">Yes</MenuItem>
      <MenuItem value="false">No</MenuItem>
    </Select>
  );
};
